<div class="">
  <!-- Toast Notification -->
  <div
    *ngIf="toastMessage"
    class="fixed top-5 right-5 z-50 text-white px-5 py-3 rounded-xl shadow-xl flex items-center space-x-3 transition-all"
    [ngClass]="toastType === 'success' ? 'bg-green-600' : 'bg-red-600'"
  >
    <svg *ngIf="toastType === 'success'" class="w-5 h-5 text-white shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
    </svg>
    <svg *ngIf="toastType === 'error'" class="w-5 h-5 text-white shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
    <span class="text-sm font-medium">{{ toastMessage }}</span>
  </div>

  <!-- Header -->
  <div class="sm:flex sm:items-center sm:justify-between">
    <div class="sm:flex-auto">
      <h1 class="text-2xl font-semibold text-gray-900">Debts</h1>
    </div>
    <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none" *ngIf="hasActiveDebts && isRefundsManager">
      <button
        type="button"
        (click)="openClearDebtModal()"
        class="inline-flex items-center justify-center rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 transition cursor-pointer"
      >
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
        Clear Debts
      </button>
    </div>
  </div>

  <!-- Debt totals -->
  <div class="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div class="bg-white shadow rounded-lg p-4 border border-gray-200">
      <div class="text-sm text-gray-500">Total Debt</div>
      <div class="text-2xl font-semibold text-gray-900">
        ${{ total_amount }}
      </div>
    </div>

    <div class="bg-white shadow rounded-lg p-4 border border-gray-200">
      <div class="text-sm text-gray-500">Remaining Debt</div>
      <div class="text-2xl font-semibold text-red-600">
        ${{ total_remaining_amount }}
      </div>
    </div>
  </div>

  <!-- Table Section -->
  <div class="mt-8 overflow-x-auto shadow ring-1 ring-gray-300 sm:rounded-lg">
    <table class="min-w-full divide-y divide-gray-200 bg-white">
      <thead class="bg-gray-50">
        <tr>
          <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Date</th>
          <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Amount</th>
          <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Remaining</th>
          <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Status</th>
          <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Transaction ID</th>
          <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Description</th>
          <th *ngIf="isRefundsManager" scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Actions</th>
        </tr>
      </thead>

      <tbody class="divide-y divide-gray-100" *ngIf="debts?.length; else loading">
        <tr *ngFor="let debt of debts">
          <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-6">
            {{ debt.created_at | date:'dd/MM/yyyy HH:mm' }}
          </td>
          <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
            ${{ debt.amount }}
          </td>
          <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
            ${{ debt.remaining_amount }}
          </td>
          <td class="whitespace-nowrap px-3 py-4 text-sm">
            <span
              [ngClass]="{
                'bg-green-500': debt.status === 'SUCCESSFULLY_RECOVERED',
                'bg-cyan-500': debt.status === 'PENDING_RECOVERY',
                'bg-yellow-400': debt.status === 'FORGIVEN',
                'bg-blue-500': debt.status === 'PARTIALLY_RECOVERED'
              }"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold text-white">
              {{ debt.status }}
            </span>
          </td>
          <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            {{ debt.transaction_uuid }}
          </td>
          <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            {{ debt.description }}
          </td>
          <td *ngIf="isRefundsManager" class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            <button
              *ngIf="debt.status === 'PENDING_RECOVERY' || debt.status === 'PARTIALLY_RECOVERED'"
              type="button"
              (click)="openClearDebtModal(debt)"
              class="inline-flex items-center justify-center rounded-md bg-red-50 px-2.5 py-1.5 text-xs font-semibold text-red-700 shadow-sm ring-1 ring-inset ring-red-300 hover:bg-red-100 transition cursor-pointer"
            >
              Clear Debt
            </button>
          </td>
        </tr>
      </tbody>

      <!-- Loading or Empty -->
      <ng-template #loading>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr>
            <td [attr.colspan]="isRefundsManager ? 7 : 6" class="py-6 text-center text-sm text-gray-500">
              <ng-container *ngIf="submitted; else empty">
                <div class="flex justify-center items-center gap-2">
                  <div class="w-5 h-5 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                  <span>Loading data...</span>
                </div>
              </ng-container>
              <ng-template #empty>
                Sorry, we couldn't find any results.
              </ng-template>
            </td>
          </tr>
        </tbody>
      </ng-template>
    </table>
  </div>

  <!-- Pagination -->
  <div class="mt-6 flex justify-center">
    <nav class="inline-flex shadow-sm rounded-md">
      <button
        (click)="goToPreviousPage()"
        [disabled]="!previousPageUrl"
        class="px-3 py-2 bg-white border border-gray-300 text-sm rounded-l-md hover:bg-gray-50 disabled:opacity-50">
        ‹
      </button>

      <button
        *ngFor="let page of pageNumbers"
        (click)="page !== '...' && loadDebts(page)"
        [disabled]="page === '...' || currentPage === page"
        [ngClass]="{
          'bg-indigo-500 text-white': currentPage === page,
          'bg-white text-gray-700': currentPage !== page && page !== '...'
        }"
        class="px-4 py-2 border border-gray-300 text-sm">
        {{ page }}
      </button>

      <button
        (click)="goToNextPage()"
        [disabled]="!nextPageUrl"
        class="px-3 py-2 bg-white border border-gray-300 text-sm rounded-r-md hover:bg-gray-50 disabled:opacity-50">
        ›
      </button>
    </nav>
  </div>

  <!-- Clear Debt Confirmation Modal -->
  <div
    *ngIf="showClearDebtModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm p-4"
  >
    <div class="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl border border-gray-100">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-xl font-semibold text-gray-900">
          {{ selectedDebt ? 'Clear Debt' : 'Clear Debts' }}
        </h2>
        <button
          type="button"
          (click)="closeClearDebtModal()"
          [disabled]="isClearingDebt"
          class="text-gray-400 hover:text-gray-500 disabled:opacity-50 cursor-pointer"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Warning Message -->
      <div class="mb-4 bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800 flex items-start space-x-2">
        <svg class="w-5 h-5 text-amber-500 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span *ngIf="selectedDebt">
          This will forgive the debt of <strong>${{ selectedDebt.remaining_amount }}</strong> (Total: ${{ selectedDebt.amount }}) for this user.
        </span>
        <span *ngIf="!selectedDebt">
          This will forgive all outstanding pending and partially recovered debts for this user.
        </span>
      </div>

      <!-- Reason Input (Optional) -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Reason <span class="text-xs text-gray-500 font-normal">(Optional)</span>
        </label>
        <input
          type="text"
          [(ngModel)]="clearDebtReason"
          [disabled]="isClearingDebt"
          placeholder="e.g. Customer hardship"
          class="w-full border border-gray-300 px-3 py-2 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
      </div>

      <!-- Comment Input (Optional) -->
      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Comment <span class="text-xs text-gray-500 font-normal">(Optional)</span>
        </label>
        <textarea
          [(ngModel)]="clearDebtComment"
          [disabled]="isClearingDebt"
          rows="3"
          placeholder="Optional additional comment"
          class="w-full border border-gray-300 px-3 py-2 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 disabled:bg-gray-100 disabled:cursor-not-allowed resize-none"
        ></textarea>
      </div>

      <!-- Actions -->
      <div class="flex justify-end space-x-3">
        <button
          type="button"
          (click)="closeClearDebtModal()"
          [disabled]="isClearingDebt"
          class="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-200 disabled:opacity-50 transition cursor-pointer"
        >
          Cancel
        </button>
        <button
          type="button"
          (click)="confirmClearDebt()"
          [disabled]="isClearingDebt"
          class="inline-flex items-center justify-center bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-700 disabled:opacity-50 transition cursor-pointer"
        >
          <div *ngIf="isClearingDebt" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
          <span>{{ selectedDebt ? 'Confirm Clear Debt' : 'Confirm Clear Debts' }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
